// API CertificateItemType.
export const CERTIFICATE_ITEM_TYPE_PROGRAM = 1;
export const CERTIFICATE_ITEM_TYPE_OBJECT = 2;
// GET api/certificates/batches/items without an item type: programs and
// learning objects together, each with its itemType (the dialog's one list).
export const CERTIFICATE_ITEM_TYPE_ALL = 0;

// en.json label of each item type.
export const CERTIFICATE_ITEM_TYPE_LABELS = {
  [CERTIFICATE_ITEM_TYPE_PROGRAM]: "learning_program",
  [CERTIFICATE_ITEM_TYPE_OBJECT]: "learning_object",
};

// API CertificateBatchStatus.
export const CERTIFICATE_BATCH_STATUS_QUEUED = 1;
export const CERTIFICATE_BATCH_STATUS_IN_PROGRESS = 2;
export const CERTIFICATE_BATCH_STATUS_READY = 3;
export const CERTIFICATE_BATCH_STATUS_FAILED = 4;

export const CERTIFICATE_BATCH_STATUS_LABELS = {
  [CERTIFICATE_BATCH_STATUS_QUEUED]: "certificate_batch_status_queued",
  [CERTIFICATE_BATCH_STATUS_IN_PROGRESS]:
    "certificate_batch_status_in_progress",
  [CERTIFICATE_BATCH_STATUS_READY]: "certificate_batch_status_ready",
  [CERTIFICATE_BATCH_STATUS_FAILED]: "certificate_batch_status_failed",
};

export const CERTIFICATE_BATCH_STATUS_SEVERITIES = {
  [CERTIFICATE_BATCH_STATUS_QUEUED]: "info",
  [CERTIFICATE_BATCH_STATUS_IN_PROGRESS]: "info",
  [CERTIFICATE_BATCH_STATUS_READY]: "success",
  [CERTIFICATE_BATCH_STATUS_FAILED]: "danger",
};

// The API refuses batches above this many certificates (TOO_MANY_CERTIFICATES).
export const CERTIFICATE_BATCH_LIMIT = 2000;

// API TrainingTypeFilter, sent as a number: Required = 0, Optional = 1, All = 2.
// Keys are the report screens' "type" values (GlobalConstants.TRAINING_TYPE_*).
export const CERTIFICATE_BATCH_TRAINING_TYPES = {
  required: 0,
  optional: 1,
  all: 2,
};

// API error codes (error body { response: "<code>" }) and the message shown for each.
export const CERTIFICATE_BATCH_ERROR_MESSAGES = {
  CERTIFICATE_NOT_SET: "certificate_batch_error_certificate_not_set",
  NO_CERTIFICATES: "certificate_batch_error_no_certificates",
  TOO_MANY_CERTIFICATES: "certificate_batch_error_too_many",
  ITEM_NOT_FOUND: "certificate_batch_error_item_not_found",
  AUDIENCE_NOT_FOUND: "certificate_batch_error_audience_not_found",
  // Saved, but its job could not be started: the API marked it Failed.
  CERTIFICATE_BATCH_NOT_STARTED: "certificate_batch_error_not_started",
};

// A create refused with this code still made a (Failed) batch, so the list
// is loaded again to show it.
export const CERTIFICATE_BATCH_NOT_STARTED = "CERTIFICATE_BATCH_NOT_STARTED";

// API error codes of a download (404 body { response: "<code>" }) and the
// message shown for each. Every other download 404 (expired, not the
// requester's, not ready) has no code.
export const CERTIFICATE_BATCH_DOWNLOAD_ERROR_MESSAGES = {
  CERTIFICATE_BATCH_FILE_MISSING: "certificate_batch_file_missing",
};

export const CERTIFICATE_BATCH_PAGE_SIZE = 20;

// NotificationType.CertificatesReady on the API: the in-app notification and
// the email sent when a batch is Ready or Failed. The email is always on (its
// switch in the notification list is disabled).
export const NOTIFICATION_TYPE_CERTIFICATES_READY = 10;
